"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eCoverageOptionId = exports.eCoverageOptionType = void 0;
var eCoverageOptionType;
(function (eCoverageOptionType) {
    eCoverageOptionType["DROP_DOWN"] = "DROP_DOWN";
    eCoverageOptionType["BUTTON_GROUP"] = "BUTTON_GROUP";
    eCoverageOptionType["ROUTE"] = "ROUTE";
    eCoverageOptionType["COVERAGE_LIMIT"] = "COVERAGE_LIMIT";
})(eCoverageOptionType = exports.eCoverageOptionType || (exports.eCoverageOptionType = {}));
var eCoverageOptionId;
(function (eCoverageOptionId) {
    eCoverageOptionId["ACCOUNT_ID"] = "accountId";
    eCoverageOptionId["TRANSPORT"] = "transport";
    eCoverageOptionId["ROUTE"] = "route";
    eCoverageOptionId["CATEGORY"] = "category";
    eCoverageOptionId["TRUCKLOAD"] = "truckload";
    eCoverageOptionId["COMMODITY"] = "commodity";
    eCoverageOptionId["FREIGHT_CLASS"] = "freightClass";
})(eCoverageOptionId = exports.eCoverageOptionId || (exports.eCoverageOptionId = {}));
//# sourceMappingURL=index.js.map